import { Outlet } from "react-router-dom";
import { useParams, useLocation } from "react-router";

import { setGlobalState, get_search_parameters } from "functions";
import Nav from "pages/generic_components/navbar.js";

export default function AnonymousRoutes() {
	let params = Object.assign(get_search_parameters(), useParams());
	setGlobalState("params", params);
	let location = useLocation();
	setGlobalState("location", location);

	return (
		<div>
			<Nav />
			<Outlet />
		</div>
	);
}
